import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductSuggestionFragmentDoc } from '../../fragments/__generated__/ProductSuggestion.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductSuggestionsQueryVariables = Types.Exact<{
  q: Types.Scalars['String']['input'];
  category?: Types.InputMaybe<Types.Scalars['String']['input']>;
  size: Types.Scalars['Int']['input'];
}>;


export type ProductSuggestionsQuery = { productSuggestions: Array<{ id: string, text: string, specific: { id: string, shortName: string, product: { id: string, pk: number, thumbnailUrl: string | null } | null } | null }> };


export const ProductSuggestionsDocument = gql`
    query ProductSuggestions($q: String!, $category: String, $size: Int!) {
  productSuggestions(q: $q, category: $category, size: $size) {
    ...ProductSuggestionFragment
  }
}
    ${ProductSuggestionFragmentDoc}`;

/**
 * __useProductSuggestionsQuery__
 *
 * To run a query within a React component, call `useProductSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSuggestionsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      category: // value for 'category'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useProductSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<ProductSuggestionsQuery, ProductSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSuggestionsQuery, ProductSuggestionsQueryVariables>(ProductSuggestionsDocument, options);
      }
export function useProductSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSuggestionsQuery, ProductSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSuggestionsQuery, ProductSuggestionsQueryVariables>(ProductSuggestionsDocument, options);
        }
export type ProductSuggestionsQueryHookResult = ReturnType<typeof useProductSuggestionsQuery>;
export type ProductSuggestionsLazyQueryHookResult = ReturnType<typeof useProductSuggestionsLazyQuery>;
export type ProductSuggestionsQueryResult = Apollo.QueryResult<ProductSuggestionsQuery, ProductSuggestionsQueryVariables>;
export function refetchProductSuggestionsQuery(variables: ProductSuggestionsQueryVariables) {
      return { query: ProductSuggestionsDocument, variables: variables }
    }